module.exports = __webpack_public_path__ + "static/img_0426-763fc6809c41c2113fedf6250d49d59f.webp";